import { render, staticRenderFns } from "./MemberPrivacyPolicy.vue?vue&type=template&id=7a50f436"
import script from "./MemberPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./MemberPrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports